// Articles du blog ajoutés en octobre 2026 : 5 articles par ville prioritaire + 7 articles thématiques.
// Règles de rédaction : aucun tiret long, aucune promesse non vérifiée, prix donnés comme repères de marché.
const COVER = {
  garden: "https://images.unsplash.com/photo-1597201278257-3687be27d954?auto=format&fit=crop&w=1600&q=80",
  tree: "https://images.unsplash.com/photo-1762903938137-49b0a145e241?auto=format&fit=crop&w=1600&q=80",
  tree2: "https://images.unsplash.com/photo-1474742509976-ddec6b387356?auto=format&fit=crop&w=1600&q=80",
  lawn: "https://images.pexels.com/photos/32500250/pexels-photo-32500250.jpeg?auto=compress&cs=tinysrgb&w=1600",
  hedge: "https://images.pexels.com/photos/3280078/pexels-photo-3280078.jpeg?auto=compress&cs=tinysrgb&w=1600",
  design: "https://images.unsplash.com/photo-1576897955702-24ad19680db3?auto=format&fit=crop&w=1600&q=80",
};

export const NEW_POSTS = [
  {
    slug: "elagage-caen-guide-arbres-regles-prix",
    title: "Élagage à Caen : quand, combien et quelles règles ?",
    excerpt: "Périodes de taille, prix constatés, règles de voisinage et démarches en mairie : tout ce qu'il faut savoir avant de faire élaguer un arbre à Caen.",
    cover: COVER.tree,
    date: "2026-10-09",
    readTime: "7 min",
    category: "Élagage",
    keywords: ["élagage caen", "élagueur caen", "prix élagage caen", "abattage caen"],
    content: `**En bref :** à Caen, un élagage se fait de préférence en hiver, hors gel, et coûte en général de 65 à 490 € par arbre selon la hauteur. Les arbres proches d'une limite de propriété, d'un réseau ou d'un bâtiment demandent plus de précautions. Le devis est gratuit chez [Pro Élagage 14](/elagage-caen).

L'**élagage à Caen** concerne autant les tilleuls et les érables des rues pavillonnaires que les grands conifères des lotissements. Dans l'agglomération, les jardins sont souvent petits et serrés : un arbre trop grand pose vite un problème de voisinage, de toiture ou de luminosité.

## Quand élaguer un arbre à Caen ?

La plupart des feuillus se taillent en hiver, de novembre à mars, quand l'arbre est en repos. La cicatrisation est meilleure et la structure des branches est visible. Évitez les jours de gel marqué, où le bois devient cassant.

Les fruitiers à noyau (cerisier, prunier) se taillent plutôt en été, juste après la récolte. Les conifères se taillent au printemps ou au début de l'automne.

Un élagage de sécurité, par exemple pour une branche cassée ou menaçante, peut se faire toute l'année. En revanche, les grosses tailles sont à éviter pendant la nidification, de mars à août. Voir les recommandations de la [LPO](https://www.lpo.fr).

## Combien coûte un élagage à Caen ?

Voici des repères de prix constatés sur le marché français. Ils servent à comparer des devis, pas à remplacer un devis.

| Prestation | Prix indicatif |
|---|---|
| Élagage d'un arbre de moins de 5 m | 65 à 115 € |
| Élagage d'un arbre de 5 à 10 m | 100 à 160 € |
| Élagage d'un arbre de 10 à 15 m | 155 à 265 € |
| Élagage d'un arbre de plus de 20 m | 340 à 490 € |

Le prix varie avec l'accès au terrain, la hauteur, la quantité de déchets à évacuer et la présence d'obstacles (toiture, câbles, clôtures). Notre déplacement depuis Caen est intégré au devis.

## Quelles règles de voisinage respecter ?

Le Code civil fixe des distances de plantation : un arbre dépassant 2 m de hauteur doit être planté à au moins 2 m de la limite de propriété. Un voisin peut aussi exiger que les branches qui avancent sur son terrain soient coupées. Le texte complet est consultable sur [Légifrance](https://www.legifrance.gouv.fr).

Certains arbres sont protégés : espace boisé classé, site inscrit, arbre remarquable au plan local d'urbanisme. En copropriété ou en lotissement, le règlement peut aussi imposer un accord. Renseignez-vous auprès de votre mairie avant une coupe importante.

## Comment se déroule une intervention ?

1. Vous nous appelez ou nous écrivez, avec quelques photos si possible.
2. Nous établissons un devis gratuit et sans engagement.
3. Une fois le devis accepté, nous intervenons sous 24 h.
4. Les grimpeurs taillent ou démontent l'arbre, avec descente par rétention quand l'espace est restreint.
5. Les déchets verts sont évacués et le chantier est laissé propre.

Notre équipe est basée à Caen, assurée en responsabilité civile professionnelle, et compte 20 ans d'expérience.

## Faut-il élaguer ou abattre ?

Un arbre sain qui gêne se règle souvent par une taille de réduction ou de dégagement. L'[abattage](/abattage-arbre-caen) devient utile quand l'arbre est mort, malade ou instable. Si la souche gêne ensuite, un [dessouchage](/dessouchage-caen) rend le terrain exploitable.

## Conclusion

**Un élagage bien planifié protège l'arbre, la toiture et les relations de voisinage.** Pour un devis gratuit à Caen, appelez le 07 80 04 43 90 ou [demandez votre devis](/contact).

## FAQ

### Faut-il une autorisation pour élaguer un arbre à Caen ?
Dans la plupart des cas chez un particulier, non. Elle peut être nécessaire pour un arbre protégé, en espace boisé classé ou en lotissement. Vérifiez auprès de la mairie avant le chantier.

### Quelle est la meilleure saison pour élaguer ?
L'hiver, entre novembre et mars, pour la majorité des feuillus. Les fruitiers à noyau se taillent après la récolte.

### Que devient le bois coupé ?
Nous évacuons les branches et les troncs, ou nous les broyons sur place si vous souhaitez du paillage. Cela est précisé dans le devis.`,
  },
  {
    slug: "jardinier-lisieux-entretien-jardin-pays-d-auge",
    title: "Jardinier à Lisieux : entretenir un jardin en Pays d'Auge",
    excerpt: "Grands terrains, haies champêtres, pommiers et terres argileuses : les spécificités d'un jardin à Lisieux et dans le Pays d'Auge, et comment les entretenir.",
    cover: COVER.hedge,
    date: "2026-10-09",
    readTime: "7 min",
    category: "Entretien",
    keywords: ["jardinier lisieux", "entretien jardin lisieux", "élagage lisieux", "pays d'auge jardin"],
    content: `**En bref :** à Lisieux et dans le Pays d'Auge, les jardins sont souvent grands, avec des haies champêtres, des pommiers et un sol argileux qui reste lourd en hiver. Un entretien régulier, calé sur la saison et sur la portance du terrain, donne les meilleurs résultats. Nous intervenons à Lisieux sous 24 h après acceptation du devis.

Un **jardinier à Lisieux** ne travaille pas comme un jardinier en ville. Entre les herbages, les maisons à pans de bois et les vergers, le jardin du Pays d'Auge demande du temps, du matériel adapté et un bon calendrier.

## Quelles particularités pour un jardin du Pays d'Auge ?

Les terrains sont souvent vastes et vallonnés. La tonte d'une grande surface prend des heures, et les abords (talus, fossés, bordures de verger) demandent un débroussaillage régulier.

Les sols sont fréquemment argileux : ils collent en hiver et durcissent en été. On évite donc de tondre ou de planter quand le terrain est détrempé, pour ne pas le tasser.

## Comment tailler les haies champêtres ?

Les haies vives du Pays d'Auge (charme, noisetier, aubépine, érable champêtre) se taillent moins sévèrement qu'une haie de laurier. Une taille latérale par an suffit en général à les garder denses. Évitez la période de nidification, de mars à fin juillet. La [taille de haie](/taille-haie-caen) se planifie donc de préférence en fin d'été ou en automne.

## Et les pommiers et les vieux arbres ?

Les pommiers à haute tige et les vieux chênes demandent une taille douce et progressive, qui garde la silhouette de l'arbre et prolonge sa vie. Pour les grands sujets, l'intervention de grimpeurs est préférable : c'est le rôle de [Pro Élagage 14 à Lisieux](/elagage-lisieux).

## Combien coûte l'entretien d'un jardin à Lisieux ?

| Prestation | Prix indicatif |
|---|---|
| Entretien de jardin, à l'heure | 25 à 45 € |
| Tonte de pelouse, au m² | 0,20 à 0,50 € |
| Taille de haie, au mètre linéaire | 2 à 15 € |
| Contrat d'entretien annuel | 400 à 2 500 € selon la surface |

Sur un grand terrain, un contrat annuel revient souvent moins cher que des passages isolés, car le rythme est fixé à l'avance. Pour un particulier, certaines prestations de jardinage peuvent ouvrir droit à un avantage fiscal, sous conditions : consultez [service-public.fr](https://www.service-public.fr).

## Comment travaille Les Jardiniers Normands ?

- Un devis gratuit, avec visite si le terrain est grand.
- Une intervention sous 24 h après acceptation du devis.
- Un matériel professionnel adapté aux grandes surfaces.
- Les déchets verts évacués, ou laissés sur place pour le compost si vous le souhaitez.

Vous pouvez consulter notre page [jardinier à Lisieux](/jardinier-lisieux) ou celle du [paysagiste à Lisieux](/paysagiste-lisieux) pour un projet de plantation.

## Conclusion

**Dans le Pays d'Auge, un bon entretien suit la saison et respecte le sol.** Pour organiser des passages réguliers ou une remise en état, [demandez un devis gratuit](/contact) ou appelez le 07 80 04 43 90.

## FAQ

### Intervenez-vous à Lisieux et dans les communes voisines ?
Oui. Lisieux fait partie de nos zones prioritaires, et nous desservons aussi Pont-l'Évêque, Orbec, Livarot et les communes alentours.

### Peut-on faire entretenir un grand terrain à l'année ?
Oui, avec un contrat d'entretien annuel qui fixe les passages (tonte, haies, désherbage) et un tarif connu à l'avance.

### Quand tailler les arbres fruitiers ?
Les pommiers se taillent en hiver, hors gel. Les fruitiers à noyau se taillent plutôt en été, après la récolte.`,
  },
  {
    slug: "elagage-abattage-falaise-guide",
    title: "Élagage et abattage à Falaise : le guide pratique",
    excerpt: "Terrains pentus, grands arbres, sols calcaires : comment se déroule un élagage ou un abattage à Falaise, et ce qu'il faut préparer avant l'intervention.",
    cover: COVER.tree2,
    date: "2026-10-09",
    readTime: "6 min",
    category: "Élagage",
    keywords: ["élagage falaise", "abattage falaise", "élagueur falaise", "jardinier falaise"],
    content: `**En bref :** à Falaise, les arbres de grande taille et les terrains parfois en pente imposent des grimpeurs expérimentés et un plan de chute maîtrisé. Les prix varient surtout avec la hauteur et l'accès. Nous intervenons à Falaise sous 24 h après acceptation du devis, y compris pour les urgences sur arbres.

Le **sud du Calvados** alterne plateaux ouverts et vallées plus encaissées. Les jardins sont souvent grands, exposés au vent, avec de vieux chênes, des frênes et de grands conifères.

## Pourquoi l'accès change tout à Falaise

Sur un terrain en pente ou éloigné de la route, on ne peut pas toujours amener un camion nacelle. Les grimpeurs montent alors dans l'arbre avec cordes et harnais, et descendent les sections par rétention pour ne rien abîmer. C'est la méthode adaptée quand l'espace est restreint, près d'un bâtiment ou d'un mur.

## Quand abattre plutôt qu'élaguer ?

Un [abattage](/abattage-arbre-caen) se justifie dans plusieurs cas :

- L'arbre est mort ou fortement dépérissant.
- Il est penché, fissuré ou déstabilisé après une tempête.
- Ses racines menacent un mur, une canalisation ou des fondations.
- Il est trop près d'une habitation pour être taillé en sécurité.

Dans les autres cas, une taille de réduction ou de dégagement garde l'arbre et règle le problème.

## Quels prix pour un abattage à Falaise ?

| Prestation | Prix indicatif |
|---|---|
| Abattage d'un arbre de moins de 5 m | 100 à 250 € |
| Abattage d'un arbre de 5 à 10 m | 250 à 500 € |
| Abattage d'un arbre de 10 à 15 m | 500 à 850 € |
| Dessouchage (souche de moins de 30 cm) | 50 à 100 € |

Ces montants sont des repères de marché. Le déplacement depuis Caen est intégré au devis, et l'évacuation du bois est précisée à l'avance.

## Faut-il une autorisation ?

Chez un particulier, c'est rarement nécessaire, mais certains cas l'imposent : espace boisé classé, site protégé, lotissement ou copropriété. La mairie de Falaise vous renseigne. Vous pouvez aussi consulter [service-public.fr](https://www.service-public.fr).

## Comment préparer l'intervention ?

1. Dégagez l'accès (véhicules, mobilier de jardin, jeux d'enfants).
2. Repérez les réseaux (câbles, canalisations) proches de l'arbre.
3. Prévenez vos voisins si l'arbre est en limite de propriété.
4. Prenez des photos de l'arbre pour accélérer le devis.

Après la coupe, la souche peut être rognée pour retrouver un terrain exploitable : voir le [dessouchage](/dessouchage-caen).

## Conclusion

**À Falaise, la sécurité du chantier dépend d'abord de l'accès et de la méthode de démontage.** Consultez notre page [élagage à Falaise](/elagage-falaise) ou [demandez un devis gratuit](/contact) au 07 80 04 43 90.

## FAQ

### Travaillez-vous à Falaise en urgence ?
Oui, Falaise fait partie de nos zones prioritaires. Après acceptation du devis, nous intervenons sous 24 h.

### Combien de temps dure un abattage ?
De quelques heures à une journée selon la hauteur, l'accès et le démontage. Le devis indique la durée prévue.

### Le bois est-il évacué ?
Oui, ou broyé sur place en paillage si vous le souhaitez. C'est précisé dans le devis.`,
  },
  {
    slug: "entretien-jardin-deauville-trouville",
    title: "Entretien de jardin à Deauville et Trouville",
    excerpt: "Villas, résidences secondaires et air marin : comment entretenir un jardin à Deauville, Trouville-sur-Mer et sur la Côte Fleurie, même en votre absence.",
    cover: COVER.design,
    date: "2026-10-09",
    readTime: "6 min",
    category: "Entretien",
    keywords: ["jardinier deauville", "entretien jardin trouville", "paysagiste deauville", "résidence secondaire jardin"],
    content: `**En bref :** sur la Côte Fleurie, le jardin doit résister au vent et aux embruns, et beaucoup de propriétaires sont absents une partie de l'année. La solution la plus simple est un entretien programmé, avec des passages avant l'été et après l'hiver. Nous intervenons à Deauville et Trouville-sur-Mer sous 24 h après acceptation du devis.

Un **jardinier à Deauville** doit composer avec le climat marin. Villas, pavillons et résidences secondaires partagent les mêmes contraintes : vent salé, sol léger et jardins souvent soignés que l'on veut retrouver impeccables à chaque séjour.

## Quels végétaux résistent à l'air marin ?

Face à la mer, on choisit des plantes tolérantes au sel et au vent :

- Haies : tamaris, escallonia, griselinia, pittosporum.
- Massifs : graminées, lavandes, sedums, hortensias abrités.
- Arbres : pins et chênes verts, à surveiller après les tempêtes.

Ces choix sont à adapter à l'exposition réelle du terrain. Un [paysagiste à Deauville](/paysagiste-deauville) peut vous conseiller avant plantation.

## Comment entretenir un jardin quand on est absent ?

L'idéal est un calendrier de passages fixé à l'avance :

1. **Avant la saison :** remise en état, taille des haies, désherbage des massifs.
2. **Pendant la saison :** tonte et taille légère à rythme régulier.
3. **Après la saison :** ramassage des feuilles, taille d'automne, protection des plantes fragiles.

Un [contrat d'entretien](/jardinier-deauville) évite les mauvaises surprises : le tarif est connu à l'avance et le jardin reste présentable toute l'année.

## Que faire des arbres exposés au vent ?

Les arbres du littoral poussent souvent inclinés par le vent dominant. Une taille d'allègement réduit la prise au vent et le risque de chute de branches. Après une tempête, une vérification visuelle est conseillée. Pour les grands sujets, l'intervention de grimpeurs est préférable : voir [élagage à Deauville](/elagage-deauville).

## Quels prix ?

| Prestation | Prix indicatif |
|---|---|
| Entretien de jardin, à l'heure | 25 à 45 € |
| Entretien complet d'un jardin (passage) | 150 à 300 € |
| Contrat d'entretien annuel | 400 à 2 500 € selon la surface |

Le prix dépend de la surface, de la fréquence et de l'accès. Le devis est gratuit.

## Conclusion

**Sur la Côte Fleurie, un entretien programmé garde le jardin beau sans que vous ayez à vous déplacer.** [Demandez un devis gratuit](/contact) ou appelez le 07 80 04 43 90.

## FAQ

### Intervenez-vous à Trouville-sur-Mer et à Touques ?
Oui. Nous desservons Deauville, Trouville-sur-Mer, Touques et les communes de la Côte Fleurie.

### Peut-on faire entretenir un jardin en notre absence ?
Oui, avec des passages programmés. Nous convenons ensemble de l'accès et du calendrier.

### Quelle est la meilleure période pour tailler une haie de bord de mer ?
Hors nidification, de préférence en fin d'été ou au début de l'automne, avec une taille plus douce et plus fréquente qu'à l'intérieur des terres.`,
  },
  {
    slug: "jardin-bord-de-mer-ouistreham-plantes-entretien",
    title: "Jardin à Ouistreham : plantes et entretien face à la mer",
    excerpt: "Vent, embruns et sols légers : choisir les bonnes plantes et organiser l'entretien d'un jardin à Ouistreham et sur la Côte de Nacre.",
    cover: COVER.garden,
    date: "2026-10-09",
    readTime: "6 min",
    category: "Paysagisme",
    keywords: ["jardinier ouistreham", "paysagiste ouistreham", "jardin bord de mer", "plantes résistantes au vent"],
    content: `**En bref :** à Ouistreham, un jardin réussi repose sur trois choix : des végétaux résistants au sel et au vent, un paillage épais pour retenir l'eau et un entretien régulier plutôt qu'intensif. Nous intervenons à Ouistreham sous 24 h après acceptation du devis.

Un **jardin à Ouistreham** vit au rythme de la mer. Le vent, les embruns et les sols légers changent les règles par rapport à un jardin de l'intérieur des terres.

## Quelles plantes choisir au bord de la mer ?

Privilégiez des plantes rustiques, souvent à feuillage coriace ou argenté :

- Arbustes : tamaris, escallonia, pittosporum, griselinia.
- Vivaces : lavandes, santolines, sedums, graminées.
- Couvre-sols : thym, géranium vivace, sedums rampants.

Évitez les plantes à grandes feuilles fragiles ou les essences méditerranéennes très gélives. Un [paysagiste à Ouistreham](/paysagiste-ouistreham) peut établir un plan de plantation adapté.

## Comment protéger le jardin du vent ?

Une haie brise-vent dense est le premier réflexe. Elle réduit la force du vent et protège les massifs situés derrière. Plantée en plusieurs espèces, elle résiste mieux aux maladies. Une taille annuelle régulière, avant la repousse de printemps, la garde dense.

## Pourquoi pailler autant ?

Le sol sableux ou léger retient peu l'eau. Un paillage de 5 à 7 cm (écorces, BRF, paille) limite l'évaporation, réduit le désherbage et améliore la vie du sol. Arrosez en profondeur et moins souvent plutôt qu'un peu chaque jour.

## Quel entretien tout au long de l'année ?

| Saison | Gestes principaux |
|---|---|
| Printemps | Tonte, désherbage, paillage, taille des arbustes défleuris |
| Été | Arrosage raisonné, taille légère, surveillance |
| Automne | Taille des haies, ramassage des feuilles, plantations |
| Hiver | Élagage hors végétation, protection des plantes fragiles |

Pour un entretien suivi, découvrez notre offre de [jardinier à Ouistreham](/jardinier-ouistreham).

## Et les arbres ?

Les arbres exposés au vent peuvent pencher ou perdre des branches. Une taille d'allègement et un contrôle après les tempêtes limitent les risques. Les interventions en hauteur sont assurées par [Pro Élagage 14](/elagage-ouistreham).

## Conclusion

**Face à la mer, choisir des plantes robustes et pailler largement fait gagner du temps chaque saison.** Pour un projet de plantation ou un entretien régulier, [demandez un devis gratuit](/contact) ou appelez le 07 80 04 43 90.

## FAQ

### Quelles haies résistent le mieux aux embruns ?
Le tamaris, l'escallonia, le pittosporum et le griselinia sont couramment utilisés en bord de mer.

### Faut-il arroser souvent un jardin de bord de mer ?
Plutôt en profondeur et moins souvent, avec un bon paillage. Les arrosages courts et fréquents favorisent des racines superficielles.

### Peut-on planter toute l'année ?
L'automne et la fin de l'hiver sont les plus favorables : le sol est humide et les racines s'installent avant l'été.`,
  },
  {
    slug: "abattage-arbre-dangereux-signes-a-surveiller",
    title: "Arbre dangereux : les signes qui imposent l'abattage",
    excerpt: "Branches mortes, fissures, champignons, inclinaison : comment reconnaître un arbre dangereux et décider entre élagage et abattage.",
    cover: COVER.tree,
    date: "2026-10-09",
    readTime: "6 min",
    category: "Abattage",
    keywords: ["arbre dangereux", "abattage arbre", "arbre malade signes", "faire abattre un arbre"],
    content: `**En bref :** un arbre devient dangereux quand il présente du bois mort important, des fissures profondes, des champignons au pied ou une inclinaison qui augmente. Dans ces cas, faites-le examiner rapidement par un professionnel : l'élagage peut suffire, mais l'abattage est parfois la seule solution sûre.

Savoir reconnaître un **arbre dangereux** permet d'agir avant l'accident. Une branche qui tombe ou un arbre qui bascule peut endommager une toiture, une clôture, un véhicule, ou blesser quelqu'un.

## Quels sont les signes d'alerte ?

- **Bois mort :** de nombreuses branches sans feuilles en pleine saison.
- **Fissures et cavités :** crevasses profondes dans le tronc ou à la fourche des branches.
- **Champignons :** consoles ou touffes au pied de l'arbre ou sur le tronc, signe possible de pourriture interne.
- **Inclinaison :** un arbre qui penche davantage qu'avant, ou dont le sol se soulève au pied.
- **Racines abîmées :** racines coupées lors de travaux, ou déchaussées.
- **Écorce qui se détache** par plaques sur une grande partie du tronc.

Un seul signe ne suffit pas toujours, mais leur accumulation doit alerter.

## Élagage ou abattage : comment décider ?

| Situation | Solution probable |
|---|---|
| Quelques branches mortes, tronc sain | Élagage sanitaire |
| Arbre trop haut ou gênant, mais sain | Taille de réduction |
| Arbre mort ou fortement malade | [Abattage](/abattage-arbre-caen) |
| Tronc fissuré ou arbre qui penche | Expertise, puis abattage si nécessaire |

Le bon réflexe est de faire évaluer l'arbre avant d'agir. Nous établissons un devis gratuit et vous disons honnêtement si une taille suffit.

## Comment se passe un abattage en sécurité ?

Si l'espace est dégagé, l'arbre peut être abattu directement, avec un plan de chute défini. S'il est près d'un bâtiment ou d'une clôture, les grimpeurs le démontent par sections et les descendent par rétention. Les déchets sont évacués ou broyés, et la souche peut être rognée par un [dessouchage](/dessouchage-caen).

## Quelles règles juridiques ?

Chez un particulier, l'abattage est rarement soumis à autorisation, mais certains arbres sont protégés (espace boisé classé, site inscrit, arbre remarquable). Le propriétaire reste responsable des dommages causés par son arbre. Renseignez-vous sur [service-public.fr](https://www.service-public.fr) ou en mairie.

## Pourquoi ne pas abattre soi-même ?

L'abattage est l'une des activités les plus risquées du jardinage : chute, tronçonneuse, trajectoire imprévue. Un professionnel dispose du matériel, de l'assurance en responsabilité civile et de l'expérience pour maîtriser la chute.

## Conclusion

**Un arbre qui montre plusieurs signes de faiblesse doit être examiné sans attendre.** Pour une évaluation et un devis gratuits dans le Calvados, appelez le 07 80 04 43 90 ou consultez [Pro Élagage 14](/elagage-caen).

## FAQ

### Un arbre qui penche est-il forcément dangereux ?
Non, certains arbres poussent inclinés depuis toujours. C'est un changement récent d'inclinaison ou un sol soulevé qui doit inquiéter.

### Qui est responsable si mon arbre tombe chez le voisin ?
Le propriétaire de l'arbre est en principe responsable des dommages, surtout si le danger était visible. Faites examiner un arbre douteux.

### Peut-on abattre un arbre après une tempête ?
Oui, si l'arbre est cassé ou instable. Il vaut mieux intervenir rapidement et en sécurité, avec un professionnel.`,
  },
  {
    slug: "prix-elagage-arbre-calvados",
    title: "Prix d'un élagage dans le Calvados : les tarifs 2026",
    excerpt: "Combien coûte l'élagage d'un arbre selon sa hauteur ? Tarifs indicatifs, facteurs qui font varier le prix et conseils pour comparer des devis.",
    cover: COVER.tree2,
    date: "2026-10-09",
    readTime: "6 min",
    category: "Élagage",
    keywords: ["prix élagage", "tarif élagage arbre", "coût élagage calvados", "devis élagage"],
    content: `**En bref :** l'élagage d'un arbre coûte en général de 65 à 115 € pour un sujet de moins de 5 m, et jusqu'à 340 à 490 € pour un arbre de plus de 20 m. L'abattage va de 100 à 850 € selon la hauteur. Ces prix sont des repères : l'accès, les obstacles et l'évacuation des déchets font varier le devis.

Le **prix d'un élagage** dépend d'abord de la taille de l'arbre. Voici les tarifs indicatifs constatés sur le marché français, à utiliser pour comparer des devis dans le Calvados.

## Tarifs indicatifs de l'élagage

| Hauteur de l'arbre | Prix indicatif |
|---|---|
| Moins de 5 m | 65 à 115 € |
| 5 à 10 m | 100 à 160 € |
| 10 à 15 m | 155 à 265 € |
| Plus de 20 m | 340 à 490 € |

## Tarifs indicatifs de l'abattage et du dessouchage

| Prestation | Prix indicatif |
|---|---|
| Abattage, moins de 5 m | 100 à 250 € |
| Abattage, 5 à 10 m | 250 à 500 € |
| Abattage, 10 à 15 m | 500 à 850 € |
| Dessouchage, souche de moins de 30 cm | 50 à 100 € |

## Qu'est-ce qui fait varier le prix ?

- **La hauteur et le diamètre** de l'arbre.
- **L'accès :** un arbre au fond d'un jardin clos coûte plus cher qu'un arbre accessible en camion.
- **Les obstacles :** toiture, câbles, clôtures, serres.
- **Le démontage :** descendre un arbre par sections demande plus de temps qu'un abattage direct.
- **L'évacuation :** les déchets verts, broyés ou emportés, sont à préciser.
- **L'urgence :** une intervention après tempête peut être plus coûteuse.

## Comment comparer deux devis ?

1. Vérifiez que les prestations sont identiques (taille, abattage, évacuation, dessouchage).
2. Demandez si l'assurance en responsabilité civile professionnelle est incluse.
3. Regardez la méthode : grimpeurs, nacelle, démontage.
4. Vérifiez que l'évacuation des déchets est comprise.
5. Méfiez-vous des prix très bas sans détail.

## Notre façon de chiffrer

Nous établissons un devis gratuit et sans engagement, après quelques photos ou une visite. Le déplacement depuis Caen est intégré. Une fois le devis accepté, nous intervenons sous 24 h. Voir nos pages [élagage à Caen](/elagage-caen) et [abattage à Caen](/abattage-arbre-caen).

## Existe-t-il des aides fiscales ?

L'élagage d'arbres n'est en général pas concerné par les avantages fiscaux liés aux services à la personne, contrairement à certains travaux d'entretien courant du jardin. Vérifiez votre situation sur [service-public.fr](https://www.service-public.fr).

## Conclusion

**Pour savoir ce que coûtera votre arbre, le plus fiable reste un devis détaillé.** [Demandez le vôtre gratuitement](/contact) ou appelez le 07 80 04 43 90.

## FAQ

### Le déplacement est-il facturé en plus ?
Chez nous, le déplacement depuis Caen est intégré au devis dans tout le Calvados.

### Les tarifs sont-ils les mêmes en ville et à la campagne ?
Les repères sont proches, mais l'accès, la hauteur et les contraintes pèsent plus que la localisation.

### Le bois coupé est-il emporté ?
L'évacuation ou le broyage est précisé dans le devis. Vous pouvez aussi garder le bois pour le chauffage ou le paillage.`,
  },
  {
    slug: "contrat-entretien-jardin-prix-fonctionnement",
    title: "Contrat d'entretien de jardin : fonctionnement et prix",
    excerpt: "Fréquence des passages, prestations incluses, tarifs et résiliation : tout comprendre avant de signer un contrat d'entretien de jardin.",
    cover: COVER.lawn,
    date: "2026-10-09",
    readTime: "6 min",
    category: "Entretien",
    keywords: ["contrat entretien jardin", "prix entretien jardin annuel", "forfait jardinier", "jardinier particulier"],
    content: `**En bref :** un contrat d'entretien de jardin fixe à l'avance les passages, les prestations et le tarif. Il revient en général de 400 à 2 500 € par an selon la surface et la fréquence. Il garde le jardin soigné sans y penser et évite de payer chaque intervention au coup par coup.

Un **contrat d'entretien de jardin** convient à ceux qui n'ont pas le temps, le matériel ou l'envie de tondre et de tailler. Voici comment il fonctionne.

## Que comprend un contrat d'entretien ?

Selon vos besoins, il peut inclure :

- La tonte de la pelouse, avec bordures nettes.
- La taille des haies et des arbustes.
- Le désherbage des massifs et des allées.
- Le ramassage des feuilles à l'automne.
- Le débroussaillage des zones envahies.
- L'évacuation des déchets verts.

Les travaux d'[élagage](/elagage-caen) de gros arbres restent en général des interventions à part, chiffrées sur devis.

## À quelle fréquence prévoir les passages ?

| Saison | Rythme courant |
|---|---|
| Printemps et été | Une visite toutes les une à deux semaines pour la tonte |
| Haies | Une à deux tailles par an selon l'essence |
| Automne | Un à deux passages pour les feuilles et la taille |
| Hiver | Peu de passages, remise en ordre ponctuelle |

Le calendrier est discuté avec vous et ajusté selon la météo et la pousse.

## Quel est le prix d'un contrat d'entretien ?

| Prestation | Prix indicatif |
|---|---|
| Entretien de jardin, à l'heure | 25 à 45 € |
| Entretien complet d'un jardin (passage) | 150 à 300 € |
| Contrat d'entretien annuel | 400 à 2 500 € selon la surface |

Le tarif dépend de la surface, du nombre de passages et de l'état du jardin. Un jardin à remettre en état demande d'abord une intervention de remise à niveau.

## Contrat ou passage ponctuel ?

Le contrat est plus économique et plus régulier pour un jardin que l'on veut toujours soigné. Le passage ponctuel convient avant une vente, après des vacances ou pour un événement. Nous proposons les deux, avec un [jardinier à Caen](/jardinier-caen) ou dans votre commune.

## Peut-on déduire une partie du coût ?

Certaines prestations de jardinage chez un particulier peuvent ouvrir droit à un crédit d'impôt pour services à la personne, dans la limite d'un plafond annuel et sous conditions. Les règles évoluent : consultez [service-public.fr](https://www.service-public.fr) avant de déclarer.

## Les points à vérifier avant de signer

1. La liste précise des prestations incluses.
2. Le nombre et la période des passages.
3. Le tarif et ses modalités de révision.
4. Les conditions de résiliation.
5. L'évacuation des déchets verts.

## Conclusion

**Un contrat d'entretien clair garantit un jardin soigné toute l'année au même prix.** [Demandez un devis gratuit](/contact) ou appelez le 07 80 04 43 90.

## FAQ

### Faut-il être présent à chaque passage ?
Non. Il suffit de prévoir l'accès au jardin. Nous convenons ensemble des modalités.

### Le contrat est-il possible pour une copropriété ou une entreprise ?
Oui, nous entretenons aussi des espaces verts de copropriétés et de professionnels, avec un contrat adapté.

### Que se passe-t-il s'il pleut ?
Le passage est décalé : on ne tond pas et on ne plante pas sur un terrain détrempé.`,
  },
  {
    slug: "erreurs-taille-arbres-a-eviter",
    title: "Taille des arbres : 6 erreurs qui les abîment",
    excerpt: "Étêtage, coupe au ras du tronc, mauvaise saison : les six erreurs de taille les plus courantes, et comment les éviter pour des arbres sains.",
    cover: COVER.tree,
    date: "2026-10-09",
    readTime: "6 min",
    category: "Élagage",
    keywords: ["erreurs taille arbre", "étêtage arbre", "comment tailler un arbre", "taille douce"],
    content: `**En bref :** les erreurs de taille les plus fréquentes sont l'étêtage, la coupe au ras du tronc, la taille en mauvaise saison, la coupe trop sévère, l'outil mal affûté et l'absence de plan. Elles affaiblissent l'arbre, favorisent les maladies et peuvent le rendre dangereux. Une taille raisonnée, avec peu de coupes bien placées, donne un arbre plus sain.

Une **mauvaise taille** abîme un arbre pour des années. Voici les six erreurs que nous rencontrons le plus souvent dans le Calvados.

## 1. L'étêtage

Couper la cime d'un arbre pour le réduire provoque une repousse de gourmands fragiles et mal attachés. L'arbre s'affaiblit, devient plus sensible aux maladies et plus dangereux à terme. Préférez une réduction progressive, en coupant sur des branches latérales.

## 2. La coupe au ras du tronc

Une coupe qui touche le tronc enlève le bourrelet cicatriciel, qui sert à refermer la plaie. Laissez ce bourrelet intact : la cicatrisation sera plus rapide et plus propre.

## 3. La mauvaise saison

La plupart des feuillus se taillent en hiver, hors gel. Les fruitiers à noyau se taillent en été, après la récolte. Évitez les grosses tailles pendant la nidification, de mars à août, et en plein pic de sève pour les essences qui saignent.

## 4. Couper trop

Retirer plus d'un quart de la ramure en une fois stresse l'arbre. Mieux vaut étaler la taille sur plusieurs années.

## 5. Des outils mal adaptés

Un sécateur émoussé ou une scie sale déchire les tissus et transmet des maladies. Affûtez et désinfectez vos outils. Pour les branches en hauteur, ne montez pas sur une échelle instable : faites appel à des grimpeurs.

## 6. Tailler sans objectif

Avant de couper, définissez ce que vous voulez : dégager une toiture, alléger la ramure, supprimer le bois mort, équilibrer la silhouette. Une taille douce (peu de coupes, petits diamètres, respect de la forme naturelle) répond à la plupart des besoins.

## Comment savoir si votre arbre a été mal taillé ?

Des repousses denses et verticales sous la coupe, des plaies qui ne se referment pas, des champignons ou une cime déformée sont des signes d'une taille inadaptée. Un professionnel peut évaluer l'arbre et proposer une taille de correction.

## Quand faire appel à un élagueur ?

Dès que l'arbre est grand, proche d'un bâtiment ou d'un réseau, ou que la taille demande de monter dans l'arbre. Chez [Pro Élagage 14](/elagage-caen), des grimpeurs expérimentés et assurés en responsabilité civile professionnelle réalisent la taille avec un matériel adapté. Les haies relèvent de la [taille de haie](/taille-haie-caen).

## Conclusion

**Une bonne taille est discrète : peu de coupes, bien placées, au bon moment.** Pour un avis et un devis gratuits, [contactez-nous](/contact) ou appelez le 07 80 04 43 90.

## FAQ

### L'étêtage est-il toujours une erreur ?
Pour la plupart des arbres, oui. Certaines tailles traditionnelles (têtards, par exemple) sont des pratiques anciennes très encadrées, à confier à un spécialiste.

### Faut-il mettre du mastic sur les plaies ?
En général non. Une coupe nette, au bon endroit, cicatrise mieux seule.

### Peut-on tailler un arbre en fleur ?
Cela dépend de l'essence. Les arbustes de printemps se taillent après la floraison.`,
  },
  {
    slug: "mousse-pelouse-normandie-que-faire",
    title: "Mousse dans la pelouse en Normandie : que faire ?",
    excerpt: "Humidité, ombre, sol tassé : pourquoi la mousse envahit les pelouses normandes, et comment la traiter et la prévenir durablement.",
    cover: COVER.lawn,
    date: "2026-10-09",
    readTime: "6 min",
    category: "Entretien",
    keywords: ["mousse pelouse", "scarification pelouse", "pelouse normandie", "gazon mousse traitement"],
    content: `**En bref :** la mousse s'installe dans une pelouse humide, ombragée, tassée ou trop rase. Pour la traiter, scarifiez au printemps ou à l'automne, aérez le sol, corrigez l'ombre et l'humidité, puis regarnissez avec un gazon adapté. Supprimer la mousse sans corriger la cause ne suffit pas : elle revient.

Le climat océanique de la Normandie, doux et humide, favorise la **mousse dans la pelouse**. Voici comment réagir.

## Pourquoi la mousse apparaît-elle ?

- **L'humidité :** sols argileux, mauvais drainage, pluies fréquentes.
- **L'ombre :** sous les arbres, le long des haies et des murs.
- **Le tassement :** passages répétés, sol compact.
- **Une tonte trop rase :** le gazon s'affaiblit et la mousse prend la place.
- **Un sol pauvre ou acide**, mal fertilisé.

## Comment traiter la mousse ?

1. **Scarifiez :** passez un scarificateur pour arracher la mousse et le feutre, au printemps ou en septembre.
2. **Aérez :** percez le sol avec une fourche-bêche ou un aérateur pour décompacter.
3. **Corrigez le sol :** sablez légèrement si le sol est lourd, apportez un amendement adapté.
4. **Regarnissez :** semez un gazon résistant à l'ombre et à l'humidité sur les zones dégarnies.
5. **Fertilisez :** un engrais adapté à la saison relance le gazon.

## Comment prévenir son retour ?

- Tondez à 5 à 6 cm, sans scalper la pelouse.
- Éclaircissez les arbres qui donnent trop d'ombre : une [taille de dégagement](/elagage-caen) laisse passer la lumière.
- Améliorez le drainage des zones qui retiennent l'eau.
- Scarifiez chaque année, au printemps ou à l'automne.
- Arrosez peu mais en profondeur en été.

## Faut-il utiliser un anti-mousse ?

Les produits anti-mousse agissent sur les symptômes, pas sur la cause. Ils peuvent aider ponctuellement, mais leur usage est à encadrer : lisez les étiquettes et renseignez-vous sur la réglementation en vigueur. Les produits phytosanitaires chimiques sont interdits à de nombreux usages pour les particuliers depuis 2019. Voir [service-public.fr](https://www.service-public.fr).

## Quand confier le travail à un professionnel ?

Une grande pelouse très envahie demande du matériel : scarificateur thermique, aérateur, semoir. Notre équipe de [jardiniers dans le Calvados](/jardinier-caen) réalise la scarification, le regarnissage et l'entretien régulier.

## Quels prix ?

| Prestation | Prix indicatif |
|---|---|
| Tonte de pelouse, au m² | 0,20 à 0,50 € |
| Création ou remise en état d'une pelouse, au m² | 3 à 7 € |
| Entretien complet d'un jardin (passage) | 150 à 300 € |

## Conclusion

**Une pelouse sans mousse repose sur un sol aéré, de la lumière et une tonte raisonnée.** [Demandez un devis gratuit](/contact) ou appelez le 07 80 04 43 90.

## FAQ

### Quand scarifier une pelouse en Normandie ?
Au printemps, quand la pousse reprend, et en septembre. Évitez les périodes de gel ou de sécheresse.

### Peut-on se contenter d'enlever la mousse ?
Non. Sans correction de la cause (ombre, humidité, tassement), elle revient rapidement.

### Faut-il semer après la scarification ?
Oui, sur les zones dégarnies, pour que le gazon reprenne la place avant la mousse.`,
  },
  {
    slug: "dechets-verts-evacuation-broyage-compost",
    title: "Déchets verts : évacuer, broyer ou composter ?",
    excerpt: "Brûlage interdit, déchetterie, broyage, compostage : que faire des déchets verts de votre jardin, et les solutions les plus pratiques.",
    cover: COVER.garden,
    date: "2026-10-09",
    readTime: "5 min",
    category: "Entretien",
    keywords: ["déchets verts", "brûlage déchets verts interdit", "broyage branches", "évacuation déchets verts"],
    content: `**En bref :** brûler ses déchets verts à l'air libre est en règle générale interdit aux particuliers. Les solutions sont le compostage, le broyage pour faire du paillage, la déchetterie ou l'évacuation par un professionnel. Pour de gros volumes, confier l'évacuation à une entreprise de jardinage fait gagner du temps.

Après une taille, une tonte ou un abattage, il reste toujours des **déchets verts**. Voici les solutions, de la plus simple à la plus complète.

## Pourquoi ne pas les brûler ?

Le brûlage des déchets verts à l'air libre pollue l'air et est en règle générale interdit aux particuliers. Les règles précises peuvent varier selon la commune : renseignez-vous en mairie et sur [service-public.fr](https://www.service-public.fr).

## Quelles solutions pour les petits volumes ?

- **Le compostage :** tontes, feuilles et petites tailles se transforment en compost en quelques mois. Alternez matières vertes (tonte) et matières brunes (feuilles, petites branches) pour un compost équilibré.
- **Le mulching :** laissez la tonte fine sur la pelouse, elle la nourrit.
- **Le paillage :** les feuilles et le broyat protègent les massifs de l'évaporation.

## Que faire des branches ?

Les branches se broient avec un broyeur de végétaux. Le broyat obtenu fait un excellent paillage, qui réduit le désherbage et l'arrosage. Pour les branches plus grosses, le bois peut servir de bois de chauffage après séchage.

## La déchetterie, une option

Les déchets verts peuvent être déposés en déchetterie. Pensez aux horaires, aux volumes autorisés et au transport. Pour une grosse taille, la remorque et les allers-retours prennent vite du temps.

## Confier l'évacuation à un professionnel

Pour de gros volumes (haies hautes, abattage, élagage), l'évacuation par une entreprise est souvent plus simple. Chez Les Jardiniers Normands et [Pro Élagage 14](/elagage-caen), les déchets verts sont évacués ou broyés selon votre choix, et le chantier est laissé propre. Ce point est précisé dans le devis.

## Comparatif rapide

| Solution | Pour quel volume | Avantage |
|---|---|---|
| Compost | Petit | Gratuit, utile pour le sol |
| Broyage et paillage | Moyen | Réduit l'arrosage et le désherbage |
| Déchetterie | Moyen à grand | Peu coûteuse, mais demande du temps |
| Évacuation par un pro | Grand | Rapide et sans effort |

## Conclusion

**Valoriser ses déchets verts sur place est plus utile que les évacuer, sauf pour les gros volumes.** Pour une taille, un abattage ou un [entretien complet](/entretien-exterieur-caen) avec évacuation, [demandez un devis gratuit](/contact) ou appelez le 07 80 04 43 90.

## FAQ

### Le brûlage de déchets verts est-il vraiment interdit ?
En règle générale oui pour les particuliers, avec quelques exceptions locales ou professionnelles. Vérifiez auprès de votre mairie.

### Que faire des branches d'un abattage ?
Elles peuvent être évacuées, broyées en paillage ou débitées en bois de chauffage. C'est à convenir dans le devis.

### L'évacuation est-elle comprise dans vos devis ?
Oui, elle est précisée dans chaque devis : évacuation, broyage sur place ou conservation par vos soins.`,
  },
  {
    slug: "jardin-automne-normandie-octobre-decembre",
    title: "Jardin en automne en Normandie : octobre à décembre",
    excerpt: "Feuilles, plantations, taille, protection des plantes fragiles : le calendrier du jardin d'octobre à décembre sous le climat normand.",
    cover: COVER.hedge,
    date: "2026-10-09",
    readTime: "6 min",
    category: "Saisonnier",
    keywords: ["jardin automne normandie", "que faire au jardin en octobre", "plantation automne", "entretien jardin novembre"],
    content: `**En bref :** d'octobre à décembre, le jardin normand se prépare à l'hiver : ramassage des feuilles, plantation des arbres et arbustes, taille des haies persistantes, scarification et protection des plantes fragiles. C'est aussi la bonne période pour élaguer les arbres avant les tempêtes d'hiver.

L'**automne en Normandie** est long et humide. Le sol est encore tiède et riche en eau, ce qui en fait la meilleure saison pour planter et préparer l'année suivante.

## Octobre : planter et ramasser

- **Plantez** arbres, arbustes et vivaces : le sol humide favorise l'enracinement.
- **Ramassez** les feuilles mortes sur la pelouse pour éviter qu'elles ne l'étouffent. Compostez-les ou utilisez-les en paillage.
- **Scarifiez et regarnissez** la pelouse, avec un gazon adapté.
- **Taillez** les haies persistantes une dernière fois avant l'hiver, hors nidification. Voir notre page [taille de haie](/taille-haie-caen).

## Novembre : élaguer et protéger

- **Élaguez** les arbres feuillus en repos végétatif, hors gel. Un élagage de sécurité avant les tempêtes limite les chutes de branches : [Pro Élagage 14](/elagage-caen).
- **Protégez** les plantes frileuses avec un voile d'hivernage ou un paillage épais.
- **Plantez** les bulbes de printemps (tulipes, narcisses) avant les gelées.
- **Nettoyez** les massifs en gardant un peu de feuillage utile aux insectes.

## Décembre : travaux d'hiver

- **Taillez** les arbres fruitiers à pépins (pommiers, poiriers) par temps sec et hors gel.
- **Faites abattre** les arbres morts ou dangereux, hors période de grand froid : voir l'[abattage](/abattage-arbre-caen).
- **Entretenez** vos outils : nettoyage, affûtage, huilage.
- **Planifiez** les travaux de printemps : création, plantations, contrat d'entretien.

## Tableau récapitulatif

| Mois | Priorités |
|---|---|
| Octobre | Plantations, feuilles, scarification |
| Novembre | Élagage, protection, bulbes |
| Décembre | Taille des fruitiers, abattages, entretien du matériel |

## Pourquoi l'automne est la bonne saison pour planter

Les racines s'installent pendant l'hiver sans la chaleur de l'été. La plante démarre mieux au printemps et demande moins d'arrosage la première année. Un [paysagiste dans le Calvados](/paysagiste-caen) peut vous aider à choisir les essences adaptées.

## Conclusion

**Bien préparé en automne, le jardin repart plus vite et plus beau au printemps.** Pour un entretien d'automne ou un élagage avant l'hiver, [demandez un devis gratuit](/contact) ou appelez le 07 80 04 43 90. Pour la suite de l'année, voyez aussi notre [calendrier saisonnier](/blog/entretien-jardin-normandie-guide-saisonnier).

## FAQ

### Quand tailler les haies en automne ?
En septembre et octobre, hors nidification, pour les haies persistantes. Les haies champêtres se taillent plutôt en fin d'été ou en hiver.

### Peut-on planter en novembre ?
Oui, tant que le sol n'est pas gelé ni détrempé. C'est même une période très favorable.

### Que faire des feuilles mortes ?
Ramassez-les sur la pelouse, puis compostez-les ou utilisez-les en paillage sous les arbustes.`,
  },
];
